module.exports = __webpack_public_path__ + "img/jpeg-icon.b3ece341.png";